export class StripeIntentData{

    public readonly clientSecret?: string;
    public readonly message?: string;

    constructor(clientSecret?: string, message?: string) {
        this.clientSecret = clientSecret;
        this.message = message;
    }
}